import DOMAnimation from './DOMAnimation';
export default DOMAnimation;